const STATUS_COLORS = {
  customer: "bg-emerald-500/10 text-emerald-400/80 border-emerald-500/30",
  qualified: "bg-ism-teal/10 text-ism-teal/80 border-ism-teal/30",
  engaged: "bg-amber-500/10 text-amber-400/80 border-amber-500/30",
  prospect: "bg-gray-500/10 text-gray-400/80 border-gray-500/30",
  new: "bg-ism-teal/10 text-ism-teal/80 border-ism-teal/30",
};

export const statusColor = (status) => STATUS_COLORS[status] || STATUS_COLORS.prospect;

export const engagementColor = (score) => {
  if (score >= 70) return "text-emerald-400/80";
  if (score >= 40) return "text-amber-400/80";
  return "text-red-400/80";
};

export const engagementOf = (account) => account.engagement || account.engagementScore || 0;

export const STATUS_OPTIONS = [
  ["all", "All Status"],
  ["prospect", "Prospect"],
  ["new", "New"],
  ["engaged", "Engaged"],
  ["qualified", "Qualified"],
  ["customer", "Customer"],
];

export const RELATIONSHIP_OPTIONS = [
  ["all", "Customers & wishlist"],
  ["customer", "Current customers"],
  ["wishlist", "Wishlist targets"],
];

export const relationshipOf = (item) => item.relationship || (item.status === "customer" ? "customer" : "wishlist");

export const relationshipBadge = (rel) =>
  rel === "customer" ? "bg-emerald-500/10 text-emerald-300 border-emerald-500/30" : "bg-ism-teal/10 text-ism-teal border-ism-teal/30";

export const isBlankAccount = (a) => !a.companyName || a.companyName === "Unknown" || a.companyName.trim() === "";

export const filterItems = (items, query, status, relationship = "all") => {
  const q = query.trim().toLowerCase();
  return items.filter((item) => {
    if (status !== "all" && item.status !== status) return false;
    if (relationship !== "all" && relationshipOf(item) !== relationship) return false;
    if (!q) return true;
    return [item.companyName, item.industry, item.contactName].some((v) => v?.toLowerCase().includes(q));
  });
};

export const emptyForm = (viewMode) =>
  viewMode === "accounts"
    ? { companyName: "", industry: "", persona: "", status: "prospect" }
    : { companyName: "", contactName: "", contactTitle: "", contactEmail: "", industry: "", status: "new" };

export const itemLabel = (viewMode) => (viewMode === "accounts" ? "Account" : "Lead");
